import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "primeng/breadcrumb";
import * as i3 from "../icon-v2/icon.component";
function BreadcrumbComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "p-breadcrumb", 5);
    i0.ɵɵlistener("onItemClick", function BreadcrumbComponent_div_3_Template_p_breadcrumb_onItemClick_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hiddenItemClicked($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("model", ctx_r1.hiddenItems);
  }
}
export class BreadcrumbComponent {
  el;
  set items(items) {
    this._items = items.map(item => {
      if ((item.label?.length || 0) > 15) {
        item.styleClass = 'breadcrumb-item-long';
      }
      return item;
    });
    this.hideAndTruncateItems();
  }
  home;
  showBreadcrumbBookmarkIcon = false;
  customIcon;
  breadcrumbClick = new EventEmitter();
  _items = [];
  shownItems = [];
  hiddenItems = [];
  hiddenItemWidths = [];
  showHiddenBreadcrumbs = false;
  sizingSmaller = false;
  sizingBigger = false;
  prevWidth = window.innerWidth;
  aproximateCharWidth = 9;
  maxTextWidth = 150;
  textPadding = 32;
  containerPadding = 32;
  separatorWidth = 12;
  constructor(el) {
    this.el = el;
  }
  // no-explicit-any is needed here because the event object can have any structure
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  onResize() {
    this.hideAndTruncateItems();
  }
  hideAndTruncateItems() {
    const content = this.el.nativeElement.querySelector('.main-breadcrumb-container');
    if (content && content.offsetWidth < this._items.length * (this.maxTextWidth + this.textPadding + this.containerPadding + this.separatorWidth) - this.separatorWidth) {
      this.setItemsDisplayStatus(content.offsetWidth);
    } else {
      this.addTooltips(this._items, content?.offsetWidth || 0);
      this.shownItems = [...this._items];
    }
  }
  setItemsDisplayStatus(containerWidth) {
    let totalItemsLength = this._items.length * (this.maxTextWidth + this.textPadding + this.containerPadding + this.separatorWidth) - this.separatorWidth;
    const ellipsisWidth = 40;
    let hasEllipsis = false;
    this.shownItems = [];
    this.hiddenItems = [];
    this._items.forEach((item, i) => {
      if (i === 0 && !this.home || i === this._items.length - 1) {
        this.shownItems.push(item);
      } else if (containerWidth < totalItemsLength) {
        if (!hasEllipsis) {
          this.shownItems.push({
            label: '...'
          });
          hasEllipsis = true;
          totalItemsLength += ellipsisWidth;
        }
        this.hiddenItems.push(item);
        totalItemsLength -= ((item.label?.length || 0) > 15 ? this.maxTextWidth : (item.label?.length || 0) * this.aproximateCharWidth) + this.textPadding + this.containerPadding + this.separatorWidth;
      } else {
        this.shownItems.push(item);
      }
    });
    this.shiftFirstItemIfNeeded(containerWidth < totalItemsLength);
    this.addTooltips(this.shownItems, containerWidth);
    this.shownItems = [...this.shownItems];
    this.hiddenItems = [...this.hiddenItems];
  }
  itemClicked(event) {
    if (event.item.label === '...') {
      this.showHiddenBreadcrumbs = !this.showHiddenBreadcrumbs;
    } else {
      this.setActiveItem(event, this._items);
      this.breadcrumbClick.emit(event.item);
      this.showHiddenBreadcrumbs = false;
      this.hiddenItems = [];
    }
  }
  addTooltips(items, containerWidth) {
    const totalLengthShown = items.reduce((acc, item) => {
      acc += (item.label?.length || 0) * this.aproximateCharWidth + this.textPadding + this.containerPadding + this.separatorWidth;
      return acc;
    }, 0);
    const needsTooltip = totalLengthShown - 12 > containerWidth;
    items.forEach(item => {
      if (needsTooltip && (item.label?.length || 0) > 15) {
        item.tooltipOptions = {
          tooltipLabel: item.label,
          tooltipPosition: 'top'
        };
      } else {
        item.tooltipOptions = {
          tooltipLabel: ''
        };
      }
    });
  }
  hiddenItemClicked(event) {
    this.setActiveItem(event, this.hiddenItems);
    this.breadcrumbClick.emit(event.item);
    this.showHiddenBreadcrumbs = false;
    this.hiddenItems = [];
  }
  setActiveItem(event, items) {
    if (items) {
      items.forEach(item => {
        if (item.styleClass === 'activeBreadcrumbItem') {
          delete item.styleClass;
        }
      });
    }
    if (this.home) {
      delete this.home.styleClass;
    }
    event.item.styleClass = 'activeBreadcrumbItem';
  }
  shiftFirstItemIfNeeded(itemsTooWide) {
    if (!this.home && itemsTooWide) {
      this.hiddenItems.unshift(this._items[0]);
      this.shownItems.shift();
    }
  }
  static ɵfac = function BreadcrumbComponent_Factory(t) {
    return new (t || BreadcrumbComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: BreadcrumbComponent,
    selectors: [["geaui-breadcrumb"]],
    hostBindings: function BreadcrumbComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("resize", function BreadcrumbComponent_resize_HostBindingHandler($event) {
          return ctx.onResize($event);
        }, false, i0.ɵɵresolveWindow);
      }
    },
    inputs: {
      items: "items",
      home: "home",
      showBreadcrumbBookmarkIcon: "showBreadcrumbBookmarkIcon",
      customIcon: "customIcon"
    },
    outputs: {
      breadcrumbClick: "breadcrumbClick"
    },
    decls: 4,
    vars: 5,
    consts: [[1, "main-breadcrumb-container"], ["color", "black", 1, "folder-icon", 3, "fileSize", "file"], ["styleClass", "main-breadcrumb", 3, "onItemClick", "model", "home"], ["class", "hidden-breadcrumbs-container", 4, "ngIf"], [1, "hidden-breadcrumbs-container"], ["styleClass", "hidden-breadcrumbs", 3, "onItemClick", "model"]],
    template: function BreadcrumbComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "geaui-icon-v2", 1);
        i0.ɵɵelementStart(2, "p-breadcrumb", 2);
        i0.ɵɵlistener("onItemClick", function BreadcrumbComponent_Template_p_breadcrumb_onItemClick_2_listener($event) {
          return ctx.itemClicked($event);
        });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(3, BreadcrumbComponent_div_3_Template, 2, 1, "div", 3);
      }
      if (rf & 2) {
        let tmp_1_0;
        i0.ɵɵadvance();
        i0.ɵɵproperty("fileSize", 16)("file", (tmp_1_0 = ctx.customIcon) !== null && tmp_1_0 !== undefined ? tmp_1_0 : ctx.showBreadcrumbBookmarkIcon ? "saved-items" : "open-folder");
        i0.ɵɵadvance();
        i0.ɵɵproperty("model", ctx.shownItems)("home", ctx.home);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showHiddenBreadcrumbs);
      }
    },
    dependencies: [i1.NgIf, i2.Breadcrumb, i3.IconComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-breadcrumb',
      template: "<div class=\"main-breadcrumb-container\">\n  <geaui-icon-v2\n    class=\"folder-icon\"\n    [fileSize]=\"16\"\n    [file]=\"customIcon ?? (showBreadcrumbBookmarkIcon ? 'saved-items' : 'open-folder')\"\n    color=\"black\"></geaui-icon-v2>\n  <p-breadcrumb\n    [model]=\"shownItems\"\n    [home]=\"home\"\n    (onItemClick)=\"itemClicked($event)\"\n    styleClass=\"main-breadcrumb\"></p-breadcrumb>\n</div>\n\n<div class=\"hidden-breadcrumbs-container\" *ngIf=\"showHiddenBreadcrumbs\">\n  <p-breadcrumb [model]=\"hiddenItems\" (onItemClick)=\"hiddenItemClicked($event)\" styleClass=\"hidden-breadcrumbs\"></p-breadcrumb>\n</div>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    items: [{
      type: Input
    }],
    home: [{
      type: Input
    }],
    showBreadcrumbBookmarkIcon: [{
      type: Input
    }],
    customIcon: [{
      type: Input
    }],
    breadcrumbClick: [{
      type: Output
    }],
    // no-explicit-any is needed here because the event object can have any structure
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    onResize: [{
      type: HostListener,
      args: ['window:resize', ['$event']]
    }]
  });
})();
